import actionTypes from '../constants/action-types';

const setTemplateBuildSlug = (templateBuildSlug) => ({
  type: actionTypes.SET_TEMPLATE_BUILD_SLUG,
  payload: { templateBuildSlug },
});

export default setTemplateBuildSlug;
